var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "actions__container" },
    [
      _c(
        "button",
        {
          ref: "searchIcon",
          staticClass: "action",
          attrs: {
            tabindex: _vm.tabIndex,
            "data-element-id": _vm.NAV_SEARCH,
            "aria-label": "search",
          },
          on: { click: _vm.emitSearchClick },
        },
        [
          _c("span", { staticClass: "common__icon common__icon--search" }, [
            _vm._v("search"),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.isNoEcommerce
        ? [
            _vm.isUserLoggedIn
              ? _c(
                  "button",
                  {
                    ref: "accountIcon",
                    staticClass: "action action--user",
                    class: { "action--user-active": _vm.isAccountPanelOpen },
                    attrs: {
                      tabindex: _vm.tabIndex,
                      "data-element-id": _vm.NAV_MYACCOUNT,
                      "aria-label": "account",
                    },
                    on: { click: _vm.emitAccountClick },
                  },
                  [
                    _c("span", { attrs: { "aria-label": "account" } }, [
                      _vm._v(_vm._s(_vm.userName.substring(0, 1))),
                    ]),
                    _vm._v(" "),
                    _vm.accountBulletIsVisible
                      ? _c("div", {
                          staticClass: "action__dot action__dot--account",
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "button",
                  {
                    ref: "accountIcon",
                    staticClass: "action action--account",
                    attrs: {
                      tabindex: _vm.tabIndex,
                      "data-element-id": _vm.NAV_MYACCOUNT,
                      "aria-label": "account",
                    },
                    on: { click: _vm.emitAccountClick },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "common__icon",
                        class: _vm.isAccountPanelOpen
                          ? "common__icon--account-red"
                          : "common__icon--account",
                        attrs: { "aria-label": "log in to or create account" },
                      },
                      [_vm._v("\n        account\n      ")]
                    ),
                    _vm._v(" "),
                    _vm.accountBulletIsVisible
                      ? _c("div", {
                          staticClass: "action__dot action__dot--account",
                        })
                      : _vm._e(),
                  ]
                ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isNoEcommerce
        ? _c(
            "button",
            {
              staticClass: "action action--bag",
              attrs: {
                "data-element-id": _vm.NAV_BAG,
                tabindex: _vm.tabIndex,
                "aria-label": "bag",
              },
              on: { click: _vm.emitCartClick },
            },
            [
              _c("span", { staticClass: "common__icon common__icon--bag" }, [
                _vm._v("bag"),
              ]),
              _vm._v(" "),
              _vm.cartQuantity
                ? _c("div", { staticClass: "number-of-products" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.formattedCartItemsLength) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? [
            _vm.isAPanelOpen
              ? _c(
                  "button",
                  { staticClass: "action", on: { click: _vm.emitCloseClick } },
                  [
                    _c(
                      "span",
                      { staticClass: "common__icon common__icon--close-bold" },
                      [_vm._v("close-bold")]
                    ),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "action action--menu",
                    on: { click: _vm.emitOpenClick },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "common__icon common__icon--menu-hamburger",
                      },
                      [_vm._v("menu")]
                    ),
                    _vm._v(" "),
                    _vm.promoBulletIsVisible
                      ? _c("div", { staticClass: "action__dot" })
                      : _vm._e(),
                  ]
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }